import getIsMobile from "components/atoms/utils/getIsMobile";
import DesktopTechCard from "./desktop";
import MobileTechCard from "./mobile";

const isMobile = getIsMobile();

export default isMobile ? MobileTechCard : DesktopTechCard;